export const characterLimits = Object.freeze({
    message: 100,
    name: 18,
});
